import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import MVSection from './components/MVSection';
import { mvs, getMVsByCategory } from '@/mocks/mvs';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '欧美MV大全',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description: '汇聚全球最新最热欧美MV，涵盖流行、摇滚、嘻哈、电子等多种风格。在线免费观看高清欧美音乐视频。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${typeof window !== 'undefined' ? window.location.origin : ''}/category/{category_slug}`,
    },
    'query-input': 'required name=category_slug',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '欧美MV大全',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description: '专注欧美音乐视频分享平台',
};

export default function Home() {
  const hotMVs = mvs.slice(0, 7);
  const latestMVs = [...mvs].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()).slice(0, 8);
  const popMVs = getMVsByCategory('pop').slice(0, 4);
  const hiphopMVs = getMVsByCategory('hiphop').slice(0, 4);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <MVSection
            title="热门推荐"
            subtitle="全球最受欢迎的欧美MV精选"
            mvs={hotMVs}
            variant="featured"
            viewAllLink="/category/pop"
          />
          <div className="w-full px-4 md:px-6 py-10 md:py-14 bg-secondary-50/50">
            <div className="max-w-7xl mx-auto">
              <MVSection
                title="流行精选"
                subtitle="Billboard Hot 100 热门流行MV"
                mvs={popMVs}
                viewAllLink="/category/pop"
                viewAllLabel="更多流行MV"
              />
            </div>
          </div>
          <MVSection
            title="嘻哈地带"
            subtitle="最火说唱与嘻哈MV"
            mvs={hiphopMVs}
            viewAllLink="/category/hiphop"
            viewAllLabel="更多嘻哈MV"
          />
          <div className="w-full px-4 md:px-6 py-10 md:py-14 bg-secondary-50/50">
            <div className="max-w-7xl mx-auto">
              <MVSection
                title="最新上线"
                subtitle="第一时间追踪最新欧美MV发布"
                mvs={latestMVs}
                viewAllLink="/category/pop"
                viewAllLabel="查看全部"
              />
            </div>
          </div>

          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-foreground-950">
            <div className="max-w-7xl mx-auto text-center">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                随时随地，畅享欧美MV
              </h2>
              <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto mb-8">
                欧美MV大全为您提供一站式欧美音乐视频观看体验，高清画质、流畅播放，追踪Billboard最新榜单。
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="p-6 rounded-xl bg-foreground-900/50">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-400 mx-auto mb-3">
                    <i className="ri-4k-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-white mb-2">高清画质</h3>
                  <p className="text-xs text-foreground-400">全高清MV播放体验</p>
                </div>
                <div className="p-6 rounded-xl bg-foreground-900/50">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400 mx-auto mb-3">
                    <i className="ri-flashlight-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-white mb-2">极速更新</h3>
                  <p className="text-xs text-foreground-400">第一时间追踪Billboard榜单</p>
                </div>
                <div className="p-6 rounded-xl bg-foreground-900/50">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500/20 text-secondary-400 mx-auto mb-3">
                    <i className="ri-global-line text-xl"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-white mb-2">多元风格</h3>
                  <p className="text-xs text-foreground-400">6大音乐风格全覆盖</p>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}